import React from 'react';
import { TorgaContext } from '../TorgaContext';
import { Browser, List, Page } from '../../utils/Layout/Layout';
import ObjectSelector from '../../utils/ObjectSelector/ObjectSelector';
import { ObjectTypes, urlToRoutineID } from '../TorgaRouter';
import Routine from './Routine';
import { actionAddRoutine } from './actions';
import { useNavigate } from 'react-router-dom';

export default function Routines() {
  const { state, dispatchAction } = React.useContext(TorgaContext);
  const [, setSearch] = React.useState('');
  const navigate = useNavigate();

  const routines = state.routines.allIDs.map((id) => state.routines.byID[id]);

  return (
    <Browser>
      <List>
        <ObjectSelector
          objects={routines}
          objectType={ObjectTypes.ROUTINES}
          urlToObject={urlToRoutineID}
          onChange={setSearch}
          onCreate={() => {
            dispatchAction(actionAddRoutine('New Routine'));
          }}
          onSelect={(id) => {
            navigate(urlToRoutineID(id));
          }}
        />
      </List>

      <Page>
        <Routine />
      </Page>
    </Browser>
  );
}
